import { Injectable } from '@angular/core';
import { ApiService } from '../api.service';

@Injectable({
    providedIn: 'root'
})
export class SaPickingService extends ApiService {
    index(params: any = {}) {
        return super.get(`/sa-pickings`, params);
    }

    show(saPickingId: any) {
        return super.get(`/sa-pickings/${saPickingId}`);
    }

    timeline(saPickingId: any) {
        return super.get(`/sa-pickings/${saPickingId}/timeline`);
    }

    edit(saPickingId: number, params: any = {}) {
        return super.get(`/sa-pickings/${saPickingId}/edit`, params);
    }

    update(saPickingId: number, body: any) {
        return super.put(`/sa-pickings/${saPickingId}`, body);
    }

    unlock(saPickingId: number | null) {
        return super.put(`/sa-pickings/${saPickingId}/unlock`, {});
    }

    send(body: any) {
        return super.post(`/sa-pickings/send`, body);
    }

    sendToIntranet(params: any = {}) {
        return super.post(`/sa-pickings/send-to-intranet`, params);
    }

    sendOneToIntranet(saPickingId: number) {
        return super.post(`/sa-pickings/${saPickingId}/send-to-intranet`);
    }

    prepareToWave(params: any = {}) {
        return super.get(`/sa-pickings/prepare-to-wave`, params);
    }

    toursRecap(params: any = {}) {
        return super.get(`/sa-pickings/tours-recap`, params);
    }

    updateTransporters(body: any) {
        return super.put(`/sa-pickings/transporters`, body);
    }

    updateDeliveryTours(body: any) {
        return super.put(`/sa-pickings/delivery-tours`, body);
    }

    updateDeliveryZones(body: any) {
        return super.put(`/sa-pickings/delivery-zones`, body);
    }

    updateDeliveryDates(body: any) {
        return super.put(`/sa-pickings/delivery-dates`, body);
    }

    storeWave(body: any) {
        return super.post(`/sa-pickings/waves`, body);
    }

    generateDeliveryNotes(body: any) {
        return super.post(`/sa-delivery-notes/generate`, body);
    }

    addToWave(body: any) {
        return super.post(`/sa-pickings/add-to-wave`, body);
    }

    removeFromWave(body: any) {
        return super.post(`/sa-pickings/remove-from-wave`, body);
    }

    cancel(saPickingId: number) {
        return super.post(`/sa-pickings/${saPickingId}/cancel`, {});
    }

    toValidate(params: any = {}) {
        return super.get(`/sa-pickings/to-validate`, params);
    }

    notValidated(params: any = {}) {
        return super.get(`/sa-pickings/not-validated`, params);
    }

    validationForm(saPickingId: number) {
        return super.get(`/sa-pickings/${saPickingId}/validate`);
    }

    validate(saPickingId: number, body: any) {
        return super.post(`/sa-pickings/${saPickingId}/validate`, body);
    }

    paperPdf(saPickingId: number) {
        return super.getFile(`/sa-pickings/${saPickingId}/paper-pdf`);
    }

    print(saPickingId: number) {
        return super.post(`/sa-pickings/${saPickingId}/print`, {});
    }

    printDepartment(body: any) {
        return super.post(`/sa-pickings/print-department`, body);
    }

    statsHourlyValidated(params: { date: string }) {
        return super.get(`/sa-pickings/stats/hourly-validated`, params);
    }

    statsHourlyValidatedDetails(params: { date: string; hour: number; status?: string }) {
        return super.get(`/sa-pickings/stats/hourly-validated/details`, params);
    }

    statsStatusCounts(params: { date: string }) {
        return super.get(`/sa-pickings/stats/status-counts`, params);
    }

    statsDailyPrepared(params: { date_from: string; date_to: string }) {
        return super.get(`/sa-pickings/stats/daily-prepared`, params);
    }

    statsDailyPreparedDetails(params: { date_from: string; date_to: string; user_code: string }) {
        return super.get(`/sa-pickings/stats/daily-prepared/details`, params);
    }

    statsDailyValidated(params: { date_from: string; date_to: string }) {
        return super.get(`/sa-pickings/stats/daily-validated`, params);
    }

    statsDailyValidatedDetails(params: { date_from: string; date_to: string; user_code: string }) {
        return super.get(`/sa-pickings/stats/daily-validated/details`, params);
    }

    toValidateForm(saPickingId: number) {
        return super.get(`/sa-pickings/${saPickingId}/to-validate`);
    }

    updateToPick(saPickingId: number, body: any) {
        return super.put(`/sa-pickings/${saPickingId}/to-validate`, body);
    }

    printMultiple(body: any) {
        return super.post(`/sa-pickings/print`, body);
    }
}
